
import { defineComponent } from 'vue'
import ActionButton from '../Shared/ActionButton.vue'
import ItemTreeSwitcher from '@/components/IndexTemplates/ItemTreeSwitcher.vue'
import { useFeatureAccess } from '@/composables/useFeatureAccess'

export default defineComponent({
  components: {
    ActionButton,
    ItemTreeSwitcher
  },
  props: {
    // The currently selected template tab; the New button is gated on write
    // access for this kind (disabled + tooltip handled by ActionButton).
    kind: { type: String, default: '' },
    treeView: { type: Boolean, default: false }
  },
  emits: ['createNewTemplate', 'itemTreeSwitcherToggled'],
  setup(props) {
    const { canWrite } = useFeatureAccess(() => props.kind)

    return { canWrite }
  }
})
